import type { IAction } from "@bbj-types/action";
import { useCallback } from "react";
import { axiosAction } from "./axios";

/**
 * This method is used to validate one action "à réaliser",
 * but is defined as batch in case of future implementations.
 */
export const usePatchActionBatch = () => {
  const [state, execute, cancel] = axiosAction<void, (Partial<Omit<IAction, "_id">> & Pick<IAction, "_id">)[], unknown>(
    {
      url: "/batch",
      method: "PATCH",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: (Partial<Omit<IAction, "_id">> & Pick<IAction, "_id">)[]) => {
      return execute({
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
